import { GlobalModalState } from './types';

export const initialState: GlobalModalState = {
    isOpen: false,
    name: '',
    payload: {},
};